import objectPath from 'object-path'
import { getApi, setHeadersConfig } from 'designer/component/action/Api'
import httpClient from 'utility/httpClient.util'

const setFileUpload = (action, data) => {
  let { mapData, isGroup, mapReceiveKey } = action
  let { formData } = data
  let requestData = {}
  Object.keys(mapData).forEach((key) => {
    if (isGroup) {
      // group
      let [secondKey, lastKey] = key.split('.')
      let name = mapReceiveKey[key]
      requestData[secondKey] = {
        ...requestData[secondKey],
        [name]: formData.hasOwnProperty(key) ? formData[key] : '',
      }
    } else {
      // no group
      let name = mapReceiveKey[key]
      requestData[name] = formData.hasOwnProperty(key) ? formData[key] : ''
    }
  })

  return requestData
}

export const uploadFile = async ({ action, data, designContext }) => {
  let api = getApi(action, { ...data, designContext })
  if (!api)
    return {
      status: 500,
      message: 'UPLOAD: no API',
      data: null,
    }
  // set request body
  let requestData = setFileUpload(action, data)
  if (!requestData)
    return {
      status: 500,
      message: 'Request data is empty.',
      data: null,
    }
  // set headers
  let config = setHeadersConfig(action)
  // send request
  let response = await httpClient
    .post(api, requestData, config)
    .then(({ data }) => {
      return { status: 200, data: data, message: 'success' }
    })
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })
  return response
}

export const refreshGallery = ({ action, designContext }) => {
  const { isUiChanged, setIsUiChanged } = designContext
  let { gallery = [] } = action
  let uiChanged = objectPath(isUiChanged)
  gallery.forEach((key) => {
    uiChanged.set(key, { isAPI: true, isRefresh: true })
  })
  setIsUiChanged(uiChanged.get(''))
  return { status: 200 }
}

export const saveMedia = ({ action, data, designContext }) => {
  let { formData } = data
  let { setFormData } = designContext
  let { load, save } = action
  let loadKey = load.key
  let loadFile = objectPath.get(formData, loadKey)
  let saveKey = save.key
  if (loadFile) {
    objectPath.set(formData, saveKey, loadFile)
    setFormData(formData)
  }
}
